import $ from "jquery"

function setSwitchToggle(element) {
    const $el = $(element);
    const $wrapper = $el.closest("[data-switcher-wrapper='true']");
    const $parent = $el.closest('.switcher');
    const checked = $el.is(':checked');

    $parent.toggleClass('checked', checked);
    $wrapper.find("[data-switcher-value='true']").toggleClass('hide', !checked);
    $wrapper.find("[data-switcher-value='false']").toggleClass('hide', checked);
}

export default function () {
    // switcher
    $(".switch-toggle", this).each(function () {
        const checkbox = $(this).find("input[type=checkbox]");
        setSwitchToggle(checkbox);
        checkbox.on('change', function () {
            setSwitchToggle(this);
        });
    });
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/switcher.js